// process
const processUrl = '/app/process'

export const getProcessPage = () => `${processUrl}`
export const createProcess = () => `${processUrl}`
export const updateProcess = (id) => `${processUrl}/${id}`
export const deleteProcess = (id) => `${processUrl}/${id}`
export const getProcessAll = () => `${processUrl}/process`
